var p = {
  "prf-prod": "prod",
  "prf-qv": "qv",
  "prf-sta": "sta",
  "prf-int": "int1",
  "prf-int2": "int2"
}, t = (r) => p[r] ?? r.replace(/^prf-/, "");
export {
  p as DATADOG_ENV_NAMES,
  t as toDatadogEnv
};

//# sourceMappingURL=datadogEnv.helper.js.map